import { ToastError } from "components/Global/Toasts/Toasty";
import { takeLatest } from "redux-saga/effects";
import { defaultReturn, generateDefaultActions, makePayload, makeWritePayload, requestSaga } from "shared-utility/store/utils/helpers";

const initialState = {
  gridRawData: null,
  isGridLoading: false,
  sourceFileDefaultMappings: null,
  dataGridRows: [],
  dataGridColumns: [],
  dataColumnOffset: null,
  dataColumnAnchorIndex: null,
  numExpectedPeriods: null,
  rowIndexSelected: null,
  rowAnchor1ColumnIndex: null,
  rowAnchor2ColumnIndex: null,
  rowAnchor1Value: null,
  rowAnchor2Value: null,
  amountOfCellsSelected: null,
  fieldValue: null,
  fieldValueToShowAndSave: null,
  dataSelectDirection: null,
  selectedSourceFile: null,
  isRangeChanged: false,
  filteredRowsSelectedIndex: null,
  rowsSelected: [],
  filteredSelectedRows: []
};

// ACTIONS

export const GET_GRID_DATA_BY_FILE_ID = generateDefaultActions("GET_GRID_DATA_BY_FILE_ID");
export const getGridDataByFileId = payload => makePayload(GET_GRID_DATA_BY_FILE_ID.value, payload);
function* getGridDataByFileIdSaga({ sourceFileId }) {
  const url = `/source-files/grid-data/${sourceFileId}`;
  yield requestSaga(GET_GRID_DATA_BY_FILE_ID, url, "GET", null, null, null, true);
}

export const GET_DEFAULT_MAPPINGS_FOR_FILE = generateDefaultActions("GET_DEFAULT_MAPPINGS_FOR_FILE");
export const getDefaultMappingsForFile = payload => makePayload(GET_DEFAULT_MAPPINGS_FOR_FILE.value, payload);
function* getDefaultMappingsForFileSaga({ vendorTypeId, mappingTypeId }) {
  const url = `/source-files/types/${vendorTypeId}/${mappingTypeId}`;
  yield requestSaga(GET_DEFAULT_MAPPINGS_FOR_FILE, url, "GET", null, null, null, true);
}

export const SET_SOURCE_FILE_FIELD_SELECTIONS = generateDefaultActions("SET_SOURCE_FILE_FIELD_SELECTIONS");
export const setSourceFileFieldSelections = payload => makeWritePayload(SET_SOURCE_FILE_FIELD_SELECTIONS.value, payload);

export const SET_SOURCE_FILE_FIELD_TO_DEFAULT = generateDefaultActions("SET_SOURCE_FILE_FIELD_TO_DEFAULT");
export const setSourceFileFieldToDefault = () => makeWritePayload(SET_SOURCE_FILE_FIELD_TO_DEFAULT.value, initialState);

export const actionCreators = {
  setSourceFileFieldSelections,
  getGridDataByFileId,
  getDefaultMappingsForFile,
  setSourceFileFieldToDefault
};

// REDUCER

export function lenderReportSourceFileFieldReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_GRID_DATA_BY_FILE_ID.failure:
      ToastError("Failed to load table source.");

      return defaultReturn({ ...state, isGridLoading: false }, null, "gridRawData");
    case GET_GRID_DATA_BY_FILE_ID.success:
      return defaultReturn({ ...state, isGridLoading: false }, payload.data, "gridRawData");
    case GET_GRID_DATA_BY_FILE_ID.value:
      return defaultReturn({ ...state, isGridLoading: true });

    case GET_DEFAULT_MAPPINGS_FOR_FILE.failure:
      return defaultReturn({ ...state }, null, "sourceFileDefaultMappings");
    case GET_DEFAULT_MAPPINGS_FOR_FILE.success:
      return defaultReturn({ ...state }, payload.data, "sourceFileDefaultMappings");
    case GET_DEFAULT_MAPPINGS_FOR_FILE.value:
      return defaultReturn({ ...state });

    case SET_SOURCE_FILE_FIELD_SELECTIONS.value:
      return defaultReturn({ ...state, ...payload });

    case SET_SOURCE_FILE_FIELD_TO_DEFAULT.value:
      return defaultReturn({ ...state, ...payload });

    default:
      return state;
  }
}

export function* lenderReportSourceFileFieldSaga() {
  yield takeLatest(GET_GRID_DATA_BY_FILE_ID.value, getGridDataByFileIdSaga);
  yield takeLatest(GET_DEFAULT_MAPPINGS_FOR_FILE.value, getDefaultMappingsForFileSaga);
}
